import { render, staticRenderFns } from "./ChatSidebar.vue?vue&type=template&id=c9736e38&"
import script from "./ChatSidebar.vue?vue&type=script&lang=ts&"
export * from "./ChatSidebar.vue?vue&type=script&lang=ts&"
import style0 from "./ChatSidebar.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/vsts/work/1/s/cypher.team.viz/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('c9736e38')) {
      api.createRecord('c9736e38', component.options)
    } else {
      api.reload('c9736e38', component.options)
    }
    module.hot.accept("./ChatSidebar.vue?vue&type=template&id=c9736e38&", function () {
      api.rerender('c9736e38', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/ChatSidebar.vue"
export default component.exports